document.addEventListener('DOMContentLoaded', () => {
  if (typeof hj === 'function') hj('stateChange', window.location.href)
})
